<template>
  <transition name="modal">
  <div class="modal-mask on-boarding-modal" @click.self="hide_on_bg_click ? hide() : null">
      <div class="modal-wrapper" @click.self="hide_on_bg_click ? hide() : null">
        <div class="modal-dialog modal-dialog--readability-md">
          <div class="modal-content">
            <div class='modal-header'>
              <template v-if="modal_title">
                <button v-if="show_close_btn" class='modal__close-btn' @click="hide" type='button'>
                  <i class='kf kf-x'></i>
                  <div class='sr-only'>Close</div>
                </button>
                <h4 class="modal-title">{{modal_title}}</h4>
              </template>
            </div>
            <div class='modal-body'>
              <slot name="body" />
            </div>

            <div class='modal-footer'>
              <div class='modal-footer__row kd-form--dark'>
                <div class="modal-footer__column txt-l" v-if="show_until_dismissed">
                  <input class="kd-form__checkbox" id="chk-dont-show-again" type="checkbox" v-model="dont_show_again">
                  <label for="chk-dont-show-again">Don't show me this again</label>
                </div>
                <div class="modal-footer__column txt-r" v-if="actionExists">
                  <a @click.stop="hide" href="javascript:;" type="button" class="inline-block-link txt-upp">{{close_btn_title}}</a>
                  <a @click="doAction" href="tour" type="button" class="inline-block-link txt-upp">{{action_btn_title}}</a>
                </div>
                <div class="modal-footer__column txt-r" v-else="true">
                  <a @click.stop="hide" href="javascript:;" type="button" class="inline-block-link txt-upp">{{close_btn_title}}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  export default {
    props: {
      modal_title: {
        type: String,
        required: false
      },

      close_btn_title: {
        type: String,
        required: false,
        default: 'Ok, got it'
      },

      action: {
        type: Function,
        required: false
      },

      action_btn_title: {
        type: String,
        required: false,
        default: 'Start'
      },

      show_close_btn: {
        type: Boolean,
        required: false,
        default: true
      },

      show_until_dismissed: {
        type: Boolean,
        required: false,
        default: true
      },

      hide_on_bg_click: {
        type: Boolean,
        default: true
      },

      stateable: {
        type: Object,
        required: false,
        default: () => {
          return {
            id: null,
            type: null,
            key: null
          }
        }
      }
    },

    data() {
      return {
        dont_show_again: false
      }
    },

    computed: {
      persistDismissal() {
        return (!this.show_until_dismissed || this.dont_show_again) &&
          !isNaN(parseInt(this.stateable.id)) &&
            !_.isEmpty(this.stateable.type) &&
              !_.isEmpty(this.stateable.key)
      },

      actionExists() {
        return _.isFunction(this.action);
      }
    },

    methods: {
      hide() {
        this.$emit('close');

        if (this.dont_show_again) {
          localStorage.setItem("dont_show_again", true);
        }

        if (this.persistDismissal)
          Kadenze.UserState.set({
            user_state: {
              data: { [this.stateable.key]: true },
              stateable_id: this.stateable.id,
              stateable_type: this.stateable.type,
            },
          })
      },

      doAction() {
        this.action();
        this.hide();
      }
    }
  }
</script>
